module.exports = __webpack_public_path__ + "img/ИФ-1(А)-042.b11f8874.png";